module.exports = __webpack_public_path__ + "img/right01.429cb68c.webp";